export enum TabType {
  FAQS = "FAQs",
  RESOURCES = "Resources",
  PendingQnA="Pending Q&A"
}